// import React, { useState, useCallback, useContext } from 'react';
// import { View, StyleSheet, TextInput, Alert, FlatList, TouchableOpacity } from 'react-native';
// import defaultStyles from "../config/styles";
// import { MaterialCommunityIcons } from "@expo/vector-icons";
// import colors from '../config/colors';
// import connectionConfig from "../config/settings";
// import configurationPost from '../config/configurationPost';
// //import settingStorage from "../config/settingStorage";
// import { ListItemAccount, ListItemSeparator } from "../components/lists";
// import routes from '../navigation/routes';
// import ActivityIndicator from '../components/ActivityIndicator';
// import { useFocusEffect } from '@react-navigation/native'
// import AuthContext from '../auth/context';

// function SearchUserScreen(props) {
//   const [searchUserFailed, setSearchUserFailed] = useState(false)
//   const [items, setItems] = useState([])
//   const [searchUser, setSearchUser] = useState(false)
//   const [loading, setLoading] = useState(false);
//   const { user, setUser } = useContext(AuthContext);

//   var itemsValidation = []
//   var profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
 
// useFocusEffect(
// useCallback(() => {
  
//   // if(JSON.parse(user).alias === 'notUser' ){//Redirecciona a la pantalla de ViewImage si el usuario es notUser
//   //   // alert('notUser')
//   //    props.navigation.navigate('ViewImage')
//   //  }
//    }, [])
// )

//   const onChangeText = async (text) => {
//     setSearchUser(false)
//     setItems([])
//     setLoading(true)
//     var post_values = {
//       textUser: text.nativeEvent.text,
//     }
//     configurationPost.body = JSON.stringify(post_values)
//     //solicita el servicio para login fixo remoto
//     await fetch(connectionConfig.apiUrl + '/searchUserFixo/select', configurationPost)
//       .then(response => response.json())
//       .then(response => {
//         //  debugger
//         setItems(response.data)
//         setLoading(false)
//         itemsValidation = response.data
//         //items = Array.from(response.data)
//         //items = JSON.parse(items)
//         setSearchUser(true)
//       })
//       .catch(err => {

//         console.log('searchUser failed :( review internet service /searchUserFixo/select', err)
//         setSearchUserFailed(true);

//       })
//     if (searchUserFailed === false) {
//       if (itemsValidation.length === 0 || items === 'error en query') {
//         Alert.alert("Notification", "User doesn't exists in fixo.");
//       } else {
//         console.log('searchUser fixo success ;) ')
//       }
//     }
//   }

//   return (
//     <View style={styles.container}>
//       <View style={styles.containerSearch}>
//         <MaterialCommunityIcons
//           name={"account-search-outline"}
//           size={35}
//           color={defaultStyles.colors.medium}
//           style={styles.icon}
//         />
//         <TextInput style={styles.input}
//           onChange={text => onChangeText(text)}
//         ></TextInput>
//       </View>

//       <ActivityIndicator visible={loading} />

//       <FlatList
//         data={items}
//         keyExtractor={(items) => items.userId.toString()}
//         renderItem={({ item, index }) => (
//           <ListItemAccount
//             image={profileUri + item.userId + '_' + item.userPhoto}
//             titleRol={item.userName}
//             onPress={() => {
//               //console.log('hola', index)
//               var foundUserChecker = "foundUserChecker"
//               props.navigation.navigate(routes.FOUND_USER, { item, index, foundUserChecker })
//             }}
//           >
//           </ListItemAccount>
//         )}>
//       </FlatList>

//     </View>
//   );
// }

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,

//   },
//   containerSearch: {
//     marginTop: "5%",
//     flexDirection: "row",
//     width: "100%",
//     height: "10%"
//   },
//   input: {
//     borderWidth: 1,
//     borderColor: colors.medium,
//     paddingLeft: 5,
//     borderRadius: 5,
//     width: "80%",
//   },
//   icon: {
//     alignSelf: "center",
//     margin: 10,
//     width: "10%",
//   }
// })

// export default SearchUserScreen;




import React, { useState, useCallback,useContext } from 'react';
import { View, StyleSheet, TextInput, Alert, FlatList, Keyboard, Dimensions, Text } from 'react-native';
import defaultStyles from "../config/styles";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import colors from '../config/colors';
import connectionConfig from "../config/settings";
import configurationPost from '../config/configurationPost';
//import settingStorage from "../config/settingStorage";
import { ListItemAccount, ListItemSeparator } from "../components/lists";
import routes from '../navigation/routes';
import ActivityIndicator from '../components/ActivityIndicator';
import { useFocusEffect } from '@react-navigation/native'
//import useAuth from "../auth/useAuth";
import NotFoundMessage from '../components/NotFoundMessage';
import AuthContext from '../auth/context';

var windowWidth = Dimensions.get('window').width;

var blockSize = 15
var pageNumber = 0
var arraySeeds = []
var pointer = 0
var textPagination = ''
var textMsg = ''


function SearchUserScreen(props) {
  useFocusEffect(
    useCallback(() => {
      pageNumber = 0
      arraySeeds = []
      pointer = 0
      Keyboard.addListener('keyboardDidShow', () => {
        // console.log('entre keyboardDidShow (:')
        setUploadVisible(true)
      })
      Keyboard.addListener('keyboardDidHide', () => {
        //console.log('entre keyboardDidHide ):')
        setUploadVisible(false)
      })
    }, [])
  )
  //const [searchUserFailed, setSearchUserFailed] = useState(false)
  const [items, setItems] = useState([])
  const [searchUser, setSearchUser] = useState(false)
  const [loading, setLoading] = useState(false);
  const [uploadVisible, setUploadVisible] = useState(false)
  const [noFaundMessage, setNoFaundMessage] = useState(false);
  const { user, setUser } = useContext(AuthContext);

  //const { user } = useAuth();

  //var itemsValidation = []
  //var profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
  var profileUri = ''
  if (connectionConfig.switchS3 === true) {
    profileUri = connectionConfig.imageUrlS3
    //console.log('SearchUserScreen -> guarda las imagenes en un bucket de aws S3  ')
  } else {
    console.log('SearchUserScreen -> else switchS3')
    //profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
  }


  // const onChangeText = async (text) => {
  //   setSearchUser(false)
  //   setItems([])
  //   setLoading(true)
  //   var post_values = {
  //     textUser: text.nativeEvent.text,
  //   }
  //   configurationPost.body = JSON.stringify(post_values)
  //   //solicita el servicio para login fixo remoto
  //   if (text.nativeEvent.text === '') { // if para cuando la caja de texto este vacía
  //     console.log('text.nativeEvent.text -> ', 0)
  //     setLoading(false)
  //   } else {
  //     await fetch(connectionConfig.apiUrl + '/searchUserFixo/select', configurationPost)
  //       .then(response => response.json())
  //       .then(response => {
  //         //  debugger
  //         setItems(response.data)
  //         setLoading(false)
  //         itemsValidation = response.data
  //         //items = Array.from(response.data)
  //         //items = JSON.parse(items)
  //         setSearchUser(true)
  //       })
  //       .catch(err => {

  //         console.log('searchUser failed :( review internet service /searchUserFixo/select', err)
  //         setSearchUserFailed(true);

  //       })
  //     if (searchUserFailed === false) {
  //       if (itemsValidation.length === 0 || items === 'error en query') {
  //         Alert.alert("No existen usuarios con ese nombre.");
  //       } else {
  //         console.log('searchUser fixo success ;) ')
  //       }
  //     }
  //   }
  // }

  //---------------------------------------------
  //servicio que se activa cuando se busca un usuario
  //---------------------------------------------
  const onChangeText = async (text) => {
    //console.log('text.nativeEvent.text -> ', 0)
    setNoFaundMessage(false)
    setItems([])
    pageNumber = 0
    arraySeeds = []
    pointer = 0
    setLoading(true)
    textPagination = text.nativeEvent.text
    var post_values = {
      //userId: props.route.params.userId,
      textUser: text.nativeEvent.text,
      pointer: pointer,
      blockSize: blockSize
    }
    if (text.nativeEvent.text === '') {
      console.log('text.nativeEvent.text -> vacio :(')
      //getFollowers()
      setLoading(false)
      setItems([])
    } else {
      configurationPost.body = JSON.stringify(post_values)
      await fetch(connectionConfig.apiUrl + '/searchUserFixo/select', configurationPost)
        .then(response => response.json())
        .then(response => {
          //  debugger
          console.log('service -> /searchUserFixo/select')
          if (response.data.length === 0) {
            setLoading(false)
            textMsg = "No se encontro un usuario con:   " + textPagination
            setNoFaundMessage(true)
          } else {
            setLoading(false)
            setItems(response.data)
          }
        })
        .catch(err => {
          setLoading(false)
          console.log('searchUser failed :( review internet service /searchUserFixo/select', err)
        })
    }

  }
  //---------------------------------------------
  //pagina la lista de usuarios para el buscador 
  //---------------------------------------------
  const getFollowersPagintionSeatch = async () => {
    setLoading(true)
    //  debugger
        console.log('text.nativeEvent.text SeatchUserScreen-> ')
    pointer = pageNumber * blockSize
    // pointer = 0
    //pageNumber = 0
    //arraySeeds = []
    var post_values = {
      /// userId: props.route.params.userId,
      textUser: textPagination,
      pointer: pointer,
      blockSize: blockSize
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/searchUserFixo/select', configurationPost)
      .then(response => response.json())
      .then(response => {

        //setItems(response.data) 
        if (response.data.length === 0) {
          if (pageNumber > 0) {
            setLoading(false)
          } else {
            // setFollowers(1)
            setLoading(false)
          }
        } else {
          pageNumber++
          if (arraySeeds.length > 0) {
            arraySeeds = [...arraySeeds, ...response.data]
          } else {
            arraySeeds = response.data
          }
          arraySeeds = quitarDuplicados(arraySeeds, 'userId')
          setItems(arraySeeds)
          setLoading(false)
        }
        //setLoading(false)
      })
      .catch(err => {
        setLoading(false)
        console.log('Failed :( review internet service => /searchUserFixo/select Pagination', err)
      })
  }

  return (
    <View style={styles.container}>
        <Text style={styles.textTitle}>
            Busca usuarios en Dichapp
        </Text>
      <View style={styles.containerSearch}>
              

        {
          //.............................................
          //Sección quita o pone el logo
          //.............................................
          uploadVisible === true ?
            null
            :
            <MaterialCommunityIcons
              name={"account-search-outline"}
              size={35}
              color={defaultStyles.colors.green}
              style={styles.icon}
            />
        }

        <TextInput style={uploadVisible ? styles.inputLeft : styles.input}
          onChange={text => onChangeText(text)}
        ></TextInput>
      </View>

      <ActivityIndicator visible={loading} />
      {
        //.............................................
        //Sección que pinta mensaje al no encontrar usuario
        //.............................................
        noFaundMessage === true ?
          <NotFoundMessage textMsg={textMsg}></NotFoundMessage>
          :
          null
      }
      <FlatList
        data={items}
        keyExtractor={(items) => items.userId.toString()}
        ItemSeparatorComponent={ListItemSeparator}
        onEndReachedThreshold={.5}
        style={styles.flat}
        onEndReached={() => {
          textPagination === '' ? 
          null
           : 
          getFollowersPagintionSeatch()
        }
        }
        renderItem={({ item, index }) => (
          <ListItemAccount
            //  image={profileUri + item.userId + '_' + item.userPhoto}
            image={profileUri + item.userId + '_' + item.userPhoto.substring(0, 19) + '_userfit.jpg'}
            titleRol={item.userName}
            onPress={() => {
              if (item.userId !== JSON.parse(user).userId) {
                var foundUserChecker = "foundUserChecker"
                //   console.log("index en onPress de SearchUserScreen ", index)
                props.navigation.navigate(routes.FOUND_USER, { item, index, foundUserChecker })
              } else {
                props.navigation.navigate(routes.NO_BOTTON)
              }
            }
            }
          >
          </ListItemAccount>
        )}
        ListFooterComponent={ // Con este truco le metes espacio abajo a los Mosaicos 24jun22 cbr
          <>
            <View style={{ height: 300 }}>
            </View>
          </>
        }
      />

    </View>
  );
}

const styles = StyleSheet.create({
  textTitle:{
    fontSize: 18,
    fontWeight: 'bold',
    color: colors.green,
    marginTop: (windowWidth * .04),
    marginLeft: (windowWidth * .04),
    alignSelf: 'center',
  },
  flat:{
    marginTop: (windowWidth * .04),
    
  },
  container: {
    flex: 1,
    backgroundColor: colors.fondoGeneral
  },
  containerSearch: {
    marginTop: "2%",
    flexDirection: "row",
    width: "100%",
    height: "8%",
    marginBottom: '2%',
  },
  input: {
    backgroundColor: defaultStyles.colors.fondoInput,
    borderWidth: 2,
    borderColor: defaultStyles.colors.fondoImagenes,
    paddingLeft: 5,
    borderRadius: 25,
    width: "80%",
    //height:  (windowWidth * .9),

  },
  icon: {
    alignSelf: "center",
    margin: 7,
    width: "10%",
  },
  inputLeft: {
    marginLeft: '10%',
    backgroundColor: defaultStyles.colors.fondoInput,
    borderWidth: 2,
    borderColor: defaultStyles.colors.fondoImagenes,
    paddingLeft: 5,
    borderRadius: 25,
    width: "80%",
    height:  (windowWidth * .12),
   // marginBottom: 333 
  }
})

export default SearchUserScreen;